import { Check } from '@phosphor-icons/react';
import classNames from 'classnames';

import * as styles from '../Pricing.css';

interface Props {
  feature: string;
  isSelected: boolean;
}

export const FeatureItem = ({ feature, isSelected }: Props) => {
  return (
    <>
      <Check
        size={16}
        className={classNames(
          'shrink-0',
          isSelected ? styles.tierFeatureIconColorSelected : styles.tierFeatureIconColor,
        )}
      />
      <span
        className={classNames(
          'text-sm leading-normal font-normal',
          isSelected ? styles.tierFeatureTextColorSelected : styles.tierFeatureTextColor,
        )}
      >
        {feature}
      </span>
    </>
  );
};
